// test1422
(1422 && 0);
